import { Eyebrow } from "./Eyebrow";
import { Button } from "./Button";
import { HeroBackdrop } from "./HeroBackdrop";
import { HERO } from "@/content/home";
import mainHero from "@/assets/hero/main-hero.jpg";
import canvasShot from "@/assets/shots/canvas-sir.png";

export function Hero() {
  return (
    <HeroBackdrop
      image={mainHero}
      aside={
        <figure className="overflow-hidden rounded-2xl border border-border bg-card shadow-lift">
          <img
            src={canvasShot}
            alt="A DjiniousLab canvas: an SIR epidemic model wired to live scopes, simulating in the browser"
            className="block w-full"
            width={1108}
            height={829}
          />
        </figure>
      }
    >
      <Eyebrow>{HERO.eyebrow}</Eyebrow>
      <h1 className="mt-5 text-4xl font-extrabold leading-[1.05] tracking-tight sm:text-5xl">
        {HERO.title}
      </h1>
      <p className="mt-5 text-xl leading-relaxed text-muted-foreground">{HERO.subtitle}</p>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <Button to={HERO.primaryCta.to}>{HERO.primaryCta.label}</Button>
        <Button to={HERO.secondaryCta.to} variant="ghost">
          {HERO.secondaryCta.label}
        </Button>
      </div>
    </HeroBackdrop>
  );
}
